import Vue from 'vue'
import { Image as VanImage } from 'vant'

Vue.use(VanImage);
